import StoreUpdateEvents from "../constants/events/StoreUpdateEvents";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import LoadingStates from "../constants/states/LoadingStates";
import ActionResultEvents from "../constants/events/ActionResultEvents";
import SecureBaseStore from "./SecureBaseStore";
import Time from "../utils/Time";


class AdvertisementBillingState {
    constructor(
        loadingState,
        selectedYear,
        selectedMonth,
        paidReservations
    ) {
        this.loadingState = loadingState;
        this.selectedYear = selectedYear;
        this.selectedMonth = selectedMonth;
        this.paidReservations = paidReservations;
    }

    equals(other) {
        return this.loadingState === other.loadingState &&
            this.selectedYear === other.selectedYear &&
            this.selectedMonth === other.selectedMonth &&
            this.paidReservations.advertisementId === other.paidReservations.advertisementId &&
            this.paidReservations.advertisementTitle === other.paidReservations.advertisementTitle &&
            this.paidReservations.spaceId === other.paidReservations.spaceId &&
            this.paidReservations.spaceTitle === other.paidReservations.spaceTitle &&
            this.paidReservations.startDate === other.paidReservations.startDate &&
            this.paidReservations.endDate === other.paidReservations.endDate &&
            this.paidReservations.created === other.paidReservations.created;
    }
}

class ImmutableAdvertisementBillingStateBuilder {

    constructor() {
        this.loadingState = LoadingStates.INITIALIZED;
        this.selectedYear = Time.getCurrentYear();
        this.selectedMonth = Time.getCurrentMonth();
        this.paidReservations = []
    }

    static fromState(state) {
        return new ImmutableAdvertisementBillingStateBuilder()
            .setLoadingState(state.loadingState)
            .setPaidReservations(state.paidReservations)
            .setSelectedDate(state.selectedYear, state.selectedMonth);
    }

    setLoadingState(loadingState) {
        this.loadingState = loadingState;
        return this;
    }

    setPaidReservations(paidReservations) {
        this.paidReservations = paidReservations;
        return this;
    }

    setSelectedDate(selectedYear, selectedMonth) {
        this.selectedYear = selectedYear;
        this.selectedMonth = selectedMonth;
        return this;
    }

    build() {
        return Object.freeze(new AdvertisementBillingState(this.loadingState, this.selectedYear, this.selectedMonth, this.paidReservations));
    }
}


class AdvertisementBillingStore extends SecureBaseStore {

    constructor() {
        super(StoreUpdateEvents.ADVERTISEMENT_BILLING_STORE_UPDATE, ImmutableAdvertisementBillingStateBuilder);
        this.subscribeToEvent(ActionResultEvents.ADVERTISEMENT_BILLING_LOADED, this.handleBillingLoaded);
        this.subscribeToEvent(UIInteractionEvents.ADVERTISEMENT_BILLING_MOUNTED, this.handleLoading);
        this.subscribeToEvent(UIInteractionEvents.ADVERTISEMENT_BILLING_SELECTED_MONTH_CHANGED, this.handleMonthChanged);
        this.subscribeToEvent(UIInteractionEvents.ADVERTISEMENT_BILLING_UNMOUNTED, this.resetStore);
    }

    handleLoading = (topic, data) => {
        return ImmutableAdvertisementBillingStateBuilder.fromState(this.state)
            .setLoadingState(LoadingStates.LOADING)
            .build();
    };

    handleMonthChanged = (topic, data) => {
        return ImmutableAdvertisementBillingStateBuilder.fromState(this.state)
            .setLoadingState(LoadingStates.LOADING)
            .setSelectedDate(data.selectedYear, data.selectedMonth)
            .build();
    };

    handleBillingLoaded = (topic, data) => {
        return ImmutableAdvertisementBillingStateBuilder.fromState(this.state)
            .setLoadingState(LoadingStates.FINISHED_LOADING)
            .setPaidReservations(data)
            .build();
    };

}

export default new AdvertisementBillingStore();